import { actionTypes } from '../reducer';

export const initialized = (isActualData: boolean, isNewEnter: boolean) => ({
    type: actionTypes.INITIALIZED,
    payload: {
        isActualData,
        isNewEnter,
    },
});
